import styled from 'styled-components'
import tw from 'twin.macro'

export const SuburbText = styled.p`
  ${tw`font-body mt-8`};
`
